<div class="resource-container table-primary">
  <div class="resource-col">
    <div class="resource-header">
      <div class="header-start">
        <h5 class="title">API's</h5>
      </div>
      <div class="header-end">
        <div class="input-group  input-group-search">
          <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
          <input type="text" class="form-control" placeholder="Search for API"
            (input)="onResourceSearch(resourceTypeMap.API, $event)" [(ngModel)]="searchApi">
        </div>
      </div>
    </div>
    <div class="resource-body">
      <ng-container *ngIf="resourcesData && resourcesData['APIs']">
        <div class="body-header" *ngIf="resourcesData['APIs'].length > 0 && !disabled">
          <a mat-button (click)="selectAll('APIs')">Select All</a>
          <a mat-button (click)="clearAll('APIs')">Clear All</a>
        </div>
        <div class="d-flex flex-wrap gap-2">
          <ng-container *ngFor="let item of resourcesData['APIs'] | filter: searchApi let i = index;let even = even">
            <button mat-raised-button
        [title]="item.resourceName"
        (click)="checkBoxCommon('APIs', i)"
        [class.accent]="item.isAssigned"
        [disabled]="disabled">
        <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[item.resourceActionName]}}) </span> </button>
          </ng-container>
        </div>
        <div *ngIf="!resourcesData || !resourcesData['APIs'] || resourcesData['APIs'].length === 0" class="no-data">
          No APIs to display
        </div>
      </ng-container>
    </div>
  </div>
  <div class="resource-col">
    <div class="resource-header">
      <div class="header-start">
        <h5 class="title">URL’s</h5>
      </div>
      <div class="header-end">
        <div class="input-group  input-group-search">
          <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
          <input type="text" class="form-control" placeholder="Search for URL’s"
            (input)="onResourceSearch(resourceTypeMap.URL, $event)" [(ngModel)]="searchUrl">
        </div>
      </div>
    </div>
    <div class="resource-body">
      <ng-container *ngIf="resourcesData && resourcesData['URLs']">
        <div class="body-header" *ngIf="resourcesData['URLs'].length > 0 && !disabled">
          <a mat-button (click)="selectAll('URLs')">Select All</a>
          <a mat-button (click)="clearAll('URLs')">Clear All</a>
        </div>
        <div class="d-flex flex-wrap gap-2">
          <ng-container *ngFor="let item of resourcesData['URLs'] | filter: searchUrl let i = index;let even = even">
            <button [disabled]="disabled" mat-raised-button [title]="item.resourceName"
              (click)="checkBoxCommon('URLs', i)" [class.accent]="item.isAssigned" class="btn btn-sm ">
              <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[item.resourceActionName]}})</span>

            </button>
          </ng-container>
        </div>
      </ng-container>
      <div *ngIf="!resourcesData || !resourcesData['URLs'] ||resourcesData['URLs'].length === 0" class="no-data">
        No URLs to display
      </div>
    </div>
  </div>
  <div class="resource-col">
    <div class="resource-header">
      <div class="header-start">
        <h5 class="title">Dashboard</h5>
      </div>
      <div class="header-end">
        <div class="input-group  input-group-search">
          <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
          <input type="text" class="form-control" placeholder="Search for Dashboard"
            (input)="onResourceSearch(resourceTypeMap.DASHBOARD, $event)" [(ngModel)]="searchDashboard">
        </div>
      </div>
    </div>
    <div class="resource-body">
      <ng-container *ngIf="resourcesData && resourcesData['Dashboards']">
        <div class="body-header" *ngIf="resourcesData['Dashboards'].length > 0 && !disabled">
          <a mat-button (click)="selectAll('Dashboards')">Select All</a>
          <a mat-button (click)="clearAll('Dashboards')">Clear All</a>
        </div>
        <div class="d-flex flex-wrap gap-2">
          <ng-container *ngFor="let item of resourcesData['URLs'] | filter: searchUrl let i = index;let even = even">
            <button [disabled]="disabled" mat-raised-button [title]="item.resourceName"
              (click)="checkBoxCommon('URLs', i)" [class.accent]="item.isAssigned" class="btn btn-sm ">
              <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[item.resourceActionName]}})</span>
            </button>
          </ng-container>
          <ng-container
            *ngFor="let item of resourcesData['Dashboards'] | filter: searchDashboard let i = index;let even = even">
            <button mat-raised-button [disabled]="disabled" [title]="item.resourceName" (click)="checkBoxCommon('Dashboards', i)"
            [class.accent]="item.isAssigned" >
              <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[item.resourceActionName]}})</span>
            </button>
          </ng-container>
        </div>
      </ng-container>
      <div *ngIf="!resourcesData || !resourcesData['Dashboards'] ||resourcesData['Dashboards'].length === 0"
        class="no-data">
        No Dashboards to display
      </div>
    </div>
  </div>
  <div class="resource-col">
    <div class="resource-header">
      <div class="header-start">
        <h5 class="title">Widget</h5>
      </div>
      <div class="header-end">
        <div class="input-group  input-group-search">
          <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
          <input type="text" class="form-control" placeholder="Search for Widget" (input)="onResourceSearch(resourceTypeMap.WIDGET, $event)"
            [(ngModel)]="searchWidget">
        </div>
      </div>
    </div>
    <div class="resource-body">
      <ng-container *ngIf="resourcesData && resourcesData['Widgets']">
        <div class="body-header" *ngIf="resourcesData['Widgets'].length > 0 && !disabled">
          <a mat-button  (click)="selectAll('Widgets')">Select All</a>
          <a mat-button  (click)="clearAll('Widgets')">Clear All</a>
        </div>
        <div class="d-flex flex-wrap gap-2">
          <ng-container *ngFor="let item of resourcesData['URLs'] | filter: searchUrl let i = index;let even = even">
            <button [disabled]="disabled" mat-raised-button [title]="item.resourceName"
              (click)="checkBoxCommon('URLs', i)" [class.accent]="item.isAssigned" class="btn btn-sm ">
              <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[item.resourceActionName]}})</span>
            </button>
          </ng-container>
          <ng-container
            *ngFor="let item of resourcesData['Widgets'] | filter: searchWidget let i = index;let even = even">
            <button [disabled]="disabled" mat-raised-button [title]="item.resourceName" (click)="checkBoxCommon('Widgets', i)"
            [class.accent]="item.isAssigned">
              <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[item.resourceActionName]}})</span>
            </button>
          </ng-container>
        </div>
      </ng-container>
      <div *ngIf="!resourcesData || !resourcesData['Widgets'] ||resourcesData['Widgets'].length === 0" class="no-data">
          No Widgets to display
      </div>
    </div>
  </div>
</div>